import {
  Container,
  Grid,
  Box,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useState, useEffect } from "react";

import Axios from "axios";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Loading } from "../../components/shared/loading";
import { HeroParticles } from "../../components/shared/HeroParticles";
import { Reveal } from "../../components/shared/Reveal";

import LanguageIcon from "@material-ui/icons/Language";
import AndroidIcon from "@material-ui/icons/Android";
import AppleIcon from "@material-ui/icons/Apple";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const PROJECTS = [
  {
    name: "WahaSantha",
    category: "E-commerce",
    logo: "/static/works/wahasantha.png",
    logoAlt: "WahaSantha logo",
    description:
      "WahaSantha is a place where a variety of needs are fulfilled from a child's to an adult, we provide quality service ranging from handmade toys to handlooms as well as essential food items such as spices, dry fruits, pickles, and nonvegetarian items like fish, dried prawns and much more.",
    links: {
      web: "https://wahasantha.com",
      android:
        "https://play.google.com/store/apps/details?id=com.arawinz.wahasantha",
      ios: "https://apps.apple.com/us/app/wahasantha/id1561768630",
    },
  },
  {
    name: "EarnOn",
    category: "Consulting",
    logo: "/static/works/earnon.png",
    logoAlt: "EarnOn logo",
    description:
      "EarnOn enables you to earn Referral Money by referring your friends, colleagues, relatives, or known contacts who require a Job, Housing, Financial Services, etc. The user can apply himself/herself for a Job or choose real estate or choose an Investment plan which is available in the EarnOn Application. After giving the user's details, the EarnOn backend team will initiate the process.",
    links: {
      web: "https://earnon.org",
      android: "https://play.google.com/store/apps/details?id=com.appp.earnon",
      ios: "https://apps.apple.com/us/app/earnon/id1561003242",
    },
  },
  {
    name: "IRISHEALTHCAREINDIA",
    category: "Health & Medical",
    description:
      "An Online Consultation Portal for a Group of General Physicians in Hyderabad.",
  },
  {
    name: "Differently Abled Special Recruitment Drive 2020-21 SPSR Nellore Dist",
    category: "Government Project",
    description:
      "A Job Application portal for Differently Abled in Nellore Region.",
  },
];

const useStyles = makeStyles({
  "@keyframes heroFadeUp": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "@keyframes heroExpand": {
    from: { width: 0, opacity: 0 },
    to: { width: 90, opacity: 1 },
  },
  "@keyframes heroShimmerSweep": {
    "0%": { backgroundPosition: "-200% center" },
    "100%": { backgroundPosition: "200% center" },
  },
  "@keyframes orbDrift": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(14px, -12px) scale(1.12)" },
  },
  "@keyframes orbDriftAlt": {
    "0%, 100%": { transform: "translate(0, 0) scale(1)" },
    "50%": { transform: "translate(-16px, 10px) scale(1.08)" },
  },
  heroSection: {
    position: "relative",
    overflow: "hidden",
    minHeight: "45vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #1a001a 0%, #2d002d 100%)",
  },
  heroOrb: {
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(60px)",
    pointerEvents: "none",
    zIndex: 0,
  },
  heroOrbOne: {
    width: 340,
    height: 340,
    top: "-16%",
    right: "6%",
    background:
      "radial-gradient(circle, rgba(199,125,199,0.35), transparent 68%)",
    animation: "$orbDrift 9s ease-in-out infinite",
  },
  heroOrbTwo: {
    width: 300,
    height: 300,
    bottom: "-22%",
    left: "2%",
    background:
      "radial-gradient(circle, rgba(155,59,155,0.3), transparent 68%)",
    animation: "$orbDriftAlt 11s ease-in-out infinite",
  },
  heroEyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "0.62rem",
    fontWeight: 700,
    letterSpacing: "2.4px",
    textTransform: "uppercase",
    color: "#e0b8e0",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(199,125,199,0.35)",
    borderRadius: 30,
    padding: "6px 16px",
    marginBottom: 18,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) both",
    "&::before": {
      content: '""',
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: "#c77dc7",
      boxShadow: "0 0 10px #c77dc7",
    },
  },
  heroContent: {
    position: "relative",
    zIndex: 1,
    textAlign: "center",
    color: "#ffffff",
    padding: "40px 20px",
    maxWidth: 700,
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
    fontWeight: 700,
    marginBottom: 10,
    backgroundImage:
      "linear-gradient(90deg, #ffffff 0%, #e0b8e0 25%, #c77dc7 50%, #e0b8e0 75%, #ffffff 100%)",
    backgroundSize: "200% auto",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    color: "transparent",
    animation:
      "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both, $heroShimmerSweep 5s linear infinite",
  },
  heroDivider: {
    width: 90,
    height: 3,
    background:
      "linear-gradient(90deg, transparent, #c77dc7 30%, #e0b8e0 50%, #c77dc7 70%, transparent)",
    margin: "16px auto",
    borderRadius: 2,
    animation: "$heroExpand 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.55s both",
  },
  heroSubtitle: {
    fontSize: "clamp(0.85rem, 1.5vw, 1rem)",
    fontWeight: 400,
    opacity: 0.9,
    maxWidth: 500,
    margin: "0 auto",
    lineHeight: 1.5,
    animation: "$heroFadeUp 0.9s cubic-bezier(0.22, 1, 0.36, 1) 0.5s both",
  },

  // ── Projects section ──
  section: {
    padding: "44px 0 56px",
    background: "#fafafa",
  },
  sectionKicker: {
    display: "block",
    fontSize: "0.62rem",
    fontWeight: 700,
    letterSpacing: "2.2px",
    textTransform: "uppercase",
    color: "#9b3b9b",
    textAlign: "center",
    marginBottom: 6,
  },
  sectionTitle: {
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#2d002d",
    textAlign: "center",
    marginBottom: 30,
    letterSpacing: "-0.01em",
  },
  workCard: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    background: "#ffffff",
    borderRadius: 20,
    border: "1px solid rgba(76,0,76,0.07)",
    padding: 24,
    boxShadow: "0 6px 20px rgba(0,0,0,0.04)",
    transition:
      "transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.35s cubic-bezier(0.22, 1, 0.36, 1), border-color 0.35s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0 18px 40px rgba(76,0,76,0.14)",
      borderColor: "rgba(76,0,76,0.14)",
    },
  },
  workLogoStrip: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 18,
    "& img": {
      height: 64,
      maxWidth: "100%",
      objectFit: "contain",
    },
  },
  workName: {
    fontSize: "1rem",
    fontWeight: 700,
    color: "#2d002d",
    letterSpacing: "-0.01em",
    lineHeight: 1.35,
    marginBottom: 10,
  },
  categoryPill: {
    alignSelf: "flex-start",
    fontSize: "0.62rem",
    fontWeight: 700,
    color: "#9b3b9b",
    textTransform: "uppercase",
    letterSpacing: "1.4px",
    background:
      "linear-gradient(135deg, rgba(199,125,199,0.15), rgba(76,0,76,0.05))",
    border: "1px solid rgba(76,0,76,0.1)",
    borderRadius: 20,
    padding: "5px 12px",
    marginBottom: 14,
  },
  workDesc: {
    fontSize: "0.82rem",
    color: "#666",
    lineHeight: 1.65,
    marginBottom: 18,
  },
  platformRow: {
    marginTop: "auto",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  platformTile: {
    width: 34,
    height: 34,
    minWidth: 34,
    borderRadius: 10,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#ffffff",
    background: "linear-gradient(135deg, #6b1b6b 0%, #4c004c 100%)",
    boxShadow: "0 6px 14px rgba(76,0,76,0.25)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "& svg": { fontSize: 18 },
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 10px 20px rgba(76,0,76,0.35)",
      color: "#ffffff",
    },
  },

  // ── Closing CTA band ──
  ctaBand: {
    position: "relative",
    overflow: "hidden",
    borderRadius: 18,
    background: "linear-gradient(135deg, #6b1b6b 0%, #4a0e4a 100%)",
    padding: "38px 30px",
    textAlign: "center",
    boxShadow: "0 16px 44px rgba(76,0,76,0.25)",
    "&::before": {
      content: '""',
      position: "absolute",
      width: 320,
      height: 320,
      borderRadius: "50%",
      top: -160,
      left: -100,
      background:
        "radial-gradient(circle, rgba(199,125,199,0.3), transparent 70%)",
      pointerEvents: "none",
    },
  },
  ctaBandTitle: {
    position: "relative",
    zIndex: 1,
    fontSize: "1.25rem",
    fontWeight: 700,
    color: "#ffffff",
    marginBottom: 8,
    letterSpacing: "-0.01em",
  },
  ctaBandSub: {
    position: "relative",
    zIndex: 1,
    fontSize: "0.82rem",
    color: "rgba(255,255,255,0.72)",
    maxWidth: 440,
    margin: "0 auto 20px",
    lineHeight: 1.6,
  },
  ctaBandBtn: {
    position: "relative",
    zIndex: 1,
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    background: "#ffffff",
    color: "#4c004c",
    fontSize: "0.8rem",
    fontWeight: 600,
    borderRadius: 11,
    padding: "10px 24px",
    textDecoration: "none",
    boxShadow: "0 8px 22px rgba(0,0,0,0.2)",
    transition: "all 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    "&, &:hover, &:focus, &:active, &:visited": {
      color: "#4c004c",
      textDecoration: "none",
    },
    "&:hover": {
      transform: "translateY(-2px)",
      boxShadow: "0 14px 30px rgba(0,0,0,0.3)",
    },
    "& svg": {
      fontSize: 16,
      transition: "transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    },
    "&:hover svg": { transform: "translateX(4px)" },
  },
});

export const OurWorks = () => {
  const classes = useStyles();

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [isloading, setIsloading] = useState(true);

  const handleClick = () => {
    const anchor = document.querySelector("#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  useEffect(() => {
    getMetaData();
  }, []);

  const getMetaData = () => {
    const formData = new FormData();
    formData.append("page", 4);
    Axios.post("/api/getmetadata", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        setMetaTitle(res.data.data.meta_title);
        setMetaKeywords(res.data.data.meta_keywords);
        setMetaDesc(res.data.data.meta_desc);
        setIsloading(false);
        handleClick();
      }
    });
  };

  return (
    <div>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta name="keywords" content={metaKeywords}></meta>
      </Helmet>
      {/* Hero Section */}
      <Box className={classes.heroSection}>
        <HeroParticles id="works-hero-particles" />
        <Box className={`${classes.heroOrb} ${classes.heroOrbOne}`} />
        <Box className={`${classes.heroOrb} ${classes.heroOrbTwo}`} />
        <Box className={classes.heroContent}>
          <span className={classes.heroEyebrow}>Portfolio</span>
          <Typography className={classes.heroTitle}>
            Our Works
          </Typography>
          <Box className={classes.heroDivider} />
          <Typography className={classes.heroSubtitle}>
            Projects we have shipped for real businesses.
          </Typography>
        </Box>
      </Box>
      {isloading ? (
        <Loading />
      ) : (
        <Box className={classes.section}>
          <Container maxWidth="lg">
            <Reveal>
              <Box>
                <span className={classes.sectionKicker}>Client Projects</span>
                <Typography className={classes.sectionTitle}>
                  Work we have delivered
                </Typography>
              </Box>
            </Reveal>

            <Grid container spacing={4} alignItems="stretch">
              {PROJECTS.map((project, i) => (
                <Grid item xs={12} sm={6} lg={4} key={project.name}>
                  <Reveal delay={(i % 3) * 90}>
                    <Box className={classes.workCard}>
                      {project.logo && (
                        <Box className={classes.workLogoStrip}>
                          <img src={project.logo} alt={project.logoAlt} />
                        </Box>
                      )}
                      <Typography className={classes.workName}>
                        {project.name}
                      </Typography>
                      <span className={classes.categoryPill}>
                        {project.category}
                      </span>
                      <Typography className={classes.workDesc}>
                        {project.description}
                      </Typography>
                      {project.links && (
                        <Box className={classes.platformRow}>
                          {project.links.web && (
                            <a
                              href={project.links.web}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={classes.platformTile}
                              aria-label={`${project.name} website`}
                            >
                              <LanguageIcon />
                            </a>
                          )}
                          {project.links.android && (
                            <a
                              href={project.links.android}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={classes.platformTile}
                              aria-label={`${project.name} on Google Play`}
                            >
                              <AndroidIcon />
                            </a>
                          )}
                          {project.links.ios && (
                            <a
                              href={project.links.ios}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={classes.platformTile}
                              aria-label={`${project.name} on the App Store`}
                            >
                              <AppleIcon />
                            </a>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Reveal>
                </Grid>
              ))}
            </Grid>

            {/* Closing CTA */}
            <Reveal>
              <Box className={classes.ctaBand} style={{ marginTop: 40 }}>
                <Typography className={classes.ctaBandTitle}>
                  Want your project on this page?
                </Typography>
                <Typography className={classes.ctaBandSub}>
                  Tell us what you need and we will build it with you.
                </Typography>
                <Link to="/get-in-touch" className={classes.ctaBandBtn}>
                  Get in Touch <ArrowForwardIcon />
                </Link>
              </Box>
            </Reveal>
          </Container>
        </Box>
      )}
    </div>
  );
};
